export default __webpack_public_path__ + "static/media/home-consulting-02.b952912c.jpg";